import { GetUserType } from '@orbit/api-types'
import React from 'react'
import { Avatar as AvatarPrimitive } from '@components/Avatar'

interface Props {
	/**
	 * Structurally typed to the three fields actually rendered, so callers that
	 * only carry avatar essentials (e.g. public-overview travelers) can reuse
	 * the same avatar as the member Balances rows.
	 */
	member: Pick<GetUserType, 'firstName' | 'lastName' | 'profilePicture'> | undefined
	size?: 'sm' | 'md'
}

/** The Balances member avatar: the Avatar primitive keyed by `member` — small in feed rows, medium elsewhere. */
export const Avatar: React.FC<Props> = ({ member, size = 'md' }) => <AvatarPrimitive user={member} size={size} />
